import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import axios from "axios";
import CertificationGroup from './CertificationGroup'

class UserSaiCertifications extends React.Component {
  state = {
    user: this.props.user,
    loading: false,
    done: false,
    saiCertificationGroups: this.props.saiCertificationGroups,
    usersCertifications: this.props.usersCertifications,
    usersCertificationStepResults: this.props.usersCertificationStepResults
  }

  render() {
    const {
      user,
      loading,
      saiCertificationGroups,
      usersCertifications,
      usersCertificationStepResults
    } = this.state;

    const {
      userSaiCertificationStatuses,
      programDirectors,
      instructorTrainers,
      trainingCenters,
      formUrl,
      isSaiAdmin,
      viewOnly
    } = this.props;

    return (
      <div>
        <h4 class="text-center">SAI Certification :&nbsp;
          {isSaiAdmin ? (
            <select
              className='form-control sai-certification-status-select'
              name='sai_certification_status'
              value={user.sai_certification_status}
              onChange={e => this.handlerChangeSaiCertificationStatus(e.target.value)}>
              {userSaiCertificationStatuses.map((userSaiCertificationStatus) =>
                <option
                  key={userSaiCertificationStatus}
                  value={userSaiCertificationStatus}
                >
                  {userSaiCertificationStatus}
                </option>
              )}
            </select>
          ) : (
            <span>{user.sai_certification_status}</span>
          )}
        </h4>
        {saiCertificationGroups.map((certificationGroup, index) =>
          <CertificationGroup
            key={`cg-${certificationGroup.id}`}
            user={user}
            certificationGroup={certificationGroup}
            usersCertifications={usersCertifications}
            usersCertificationStepResults={usersCertificationStepResults}
            programDirectors={programDirectors}
            instructorTrainers={instructorTrainers}
            trainingCenters={trainingCenters}
            handlerAddStep={this.handlerAddStep}
            formUrl={formUrl}
            handleCertificationUpdate={this.handleCertificationUpdate}
            isSaiAdmin={isSaiAdmin}
            viewOnly={viewOnly}
          />
        )}
      </div>
    );
  }

  handlerAddStep = (certificationStep) => {
    const usersCertificationStepResults = this.state.usersCertificationStepResults;

    if (!Array.isArray(usersCertificationStepResults[certificationStep.id])) {
      usersCertificationStepResults[certificationStep.id] = [];
    }

    usersCertificationStepResults[certificationStep.id].push({
      name: certificationStep.name,
      certification_step_id: certificationStep.id,
      completed_date: null,
      program_director_id: this.props.programDirectors[0].id,
      instructor_trainer_id: this.props.instructorTrainers[0].id,
      training_center_id: this.props.trainingCenters[0].id,
      latest_sai_step: true
    })

    this.setState({ usersCertificationStepResults: usersCertificationStepResults });
  };

  handleCertificationUpdate = (certification) => {
    var usersCertifications = this.state.usersCertifications;
    var usersCertificationIndex = usersCertifications.findIndex((usersCertification => usersCertification.id == certification.id));
    if (usersCertificationIndex == -1) {
      usersCertifications.push(certification);
    } else {
      usersCertifications[usersCertificationIndex].expiration_date = certification.expiration_date;
    };

    this.setState({ usersCertifications: usersCertifications });
  };

  handlerChangeSaiCertificationStatus = (saiCertificationStatus) => {
    let that = this;
    const data = new FormData();
    data.append(`user[sai_certification_status]`, saiCertificationStatus);

    axios.put(
      "/users/" + this.state.user.id + ".json",
      data
    ).then(request => {
      toastr.success("Sai Certification Status Updated");
      console.log("request", request)
      this.setState({user: request.data})
    })
      .catch(function(error) {
      toastr.error("There is an error, please check");
    });
  };
}

UserSaiCertifications.propTypes = {
  formName: PropTypes.string,
  formUrl: PropTypes.string,
  user: PropTypes.object,
  saiCertificationStatuses: PropTypes.array,
  saiCertificationGroups: PropTypes.array,
  usersCertifications: PropTypes.array,
  usersCertificationStepResults: PropTypes.object,
  programDirectors: PropTypes.array,
  instructorTrainers: PropTypes.array,
  trainingCenters: PropTypes.array,
  isSaiAdmin: PropTypes.bool,
  viewOnly: PropTypes.bool
};

export default UserSaiCertifications;
